import React, { useEffect, useState } from "react";
import Header from "../../components/header";
import CardLeftRight from "../../components/cardleftright";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { DataLists } from "../../dataLists/DataLists";
import { dataListsType } from "../../shared/type";
import AdPage from "../../components/AdPage";
import Currency from "../../components/currency";
import { Helmet } from "react-helmet";

const Article: React.FC = () => {
  const { slug } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  // const slug = queryParams.get("slug");
  console.log("slug--->", slug);
  console.log("location--->", location);

  const [currentItem, setCurrentItem] = useState<dataListsType | null>(null);
  const [recommended, setRecommended] = useState<dataListsType[]>([]);
  const [isShow, setIsShow] = useState(false);

  // 🔥 找文章（用 urlinform 當 slug）
  useEffect(() => {
    if (!slug) return;

    const item = DataLists.find((i) => i.urlinform === slug);
    setCurrentItem(item || null);
  }, [slug]);

  // 推薦文章
  useEffect(() => {
    const randomData = [...DataLists].sort(() => 0.5 - Math.random());
    setRecommended(randomData.slice(0, 6));
  }, []);

  // 🔥 react-snap 關鍵（等 render 完）
  useEffect(() => {
    if (navigator.userAgent === "ReactSnap") {
      setTimeout(() => {
        window.snapSaveState && window.snapSaveState();
      }, 0);
    }
  }, [currentItem]);

  if (!currentItem) return <div>Loading...</div>;

  // SEO 資料
  const title = `${currentItem.title} | ${currentItem.nation} ${currentItem.category} | Explore Asia`;

  const description = `Discover ${currentItem.title} in ${
    currentItem.nation
  }. ${currentItem.description || ""}`;

  const image = Array.isArray(currentItem.images)
    ? currentItem.images[0]
    : currentItem.images;

  const url = `https://exploreasiait.com/article/${currentItem.urlinform}`;

  // 🔥 結構化資料（超重要）
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: currentItem.title,
    description: description,
    image: image,
    author: {
      "@type": "Organization",
      name: "Explore Asia",
    },
    publisher: {
      "@type": "Organization",
      name: "Explore Asia",
    },
    mainEntityOfPage: url,
  };

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={url} />

        {/* OG */}
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={url} />

        {/* JSON-LD */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <Header />
      <AdPage />
      <div className="w-full h-full fixed top-0 left-0 -z-10 bg-white/90 bg-blend-overlay backdrop-blur-md"></div>
      {/* 🔥 文章內容（不再用 iframe） */}
      <div className="w-full flex justify-center">
        {/* <div className=""> */}
          {/* <h1 className="text-3xl font-bold mb-4">{currentItem.title}</h1> */}

          {/* CSS 注入 */}
          <style>{currentItem.css}</style>

          {/* HTML 注入 */}
          <div
            dangerouslySetInnerHTML={{
              __html: currentItem.body || "",
            }}
          />
        {/* </div> */}
      </div>

      {/* 匯率工具 */}
      <div className="w-full flex flex-col justify-center items-center mb-6">
        <div className="w-full max-w-[968px] px-10">
          <span className="p-0">
            Need to know the exchange rate?{" "}
            <b
              className="text-[#181818] cursor-pointer"
              onClick={() => setIsShow(!isShow)}
            >
              Click here.
            </b>
          </span>
        </div>

        {isShow && (
          <>
            <div className="w-full max-w-[968px] px-1 flex justify-center bg-red-0">
              <Currency />
            </div>
          </>
        )}
      </div>

      {/* 推薦 */}
      <div className="w-full flex justify-center">
        <div className="flex flex-col justify-center 2xl:max-w-[1500px] max-w-[1200px] mt-5 mb-10">
          <div className="w-full mb-16 px-8">
            <div className="mb-8 border-b-[1px]">
              <h5 className="uppercase text-sm font-semibold pt-2 pb-2 tracking-wider flex justify-between">
                <span>
                  <b className="text-[#181818]">Recommended</b>
                </span>
              </h5>
              {/* <span className="block w-14 h-[3px] bg-black"></span> */}
              <span className="block w-16 h-[3px] bg-[#c9b077]"></span>
            </div>
            <div className="w-full flex flex-col gap-y-10">
              <CardLeftRight props={recommended} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Article;
